module.exports = __webpack_public_path__ + "img/kehu_1@2x.ddf54283.png";